import { render, staticRenderFns } from "./CustomOptions.vue?vue&type=template&id=0cf5443e&scoped=true"
import script from "./CustomOptions.vue?vue&type=script&lang=js"
export * from "./CustomOptions.vue?vue&type=script&lang=js"
import style0 from "./CustomOptions.vue?vue&type=style&index=0&id=0cf5443e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5443e",
  null
  
)

export default component.exports